export const GROUP_INNER_BORDER = 2;
export const GROUP_MARGIN = 24;
export const GROUP_NODE_GAP = 12;
export const GROUP_NODE_WIDTH = 236;
export const NODE_TRACKER_WIDTH = 12;
export const MAX_SUBNODES = 9;
